import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './Marketing2.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import {
    Row, Col
} from 'reactstrap';
import Files from '../Files/Files';
import Marketing2Calls from './Marketing2Calls';
import Marketing2Emails from './Marketing2Emails';
import Marketing2Invitations from './Marketing2Invitations';
import Marketing2Types from './Marketing2Types';
import Marketing2Campaigns from './Marketing2Campaigns';
import Marketing2ConfigureCampaign from './Marketing2ConfigureCampaign';
import PermissionWrapper from '../../auth/PermissionWrapper';
import { Prompt } from 'react-router-dom';
import CompanyContext from '../../auth/CompanyContext';

// import Marketing2Activities from './Marketing2Activities';
class Marketing2Container extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.blankMarketingCampaign = {
            campaignID: 0,
            name: '',
            description: '',
            type: '',
            startDate: '',
            endDate: '',
            auth0: '',
            components: [],
            companies: 0,
            active: true,
            private: false
        }
        this.blankEmail = {
            emailID: 0,
            name: '',
            emailTypeID: 0,
            subject: '',
            text: '',
            attachments: [],
            active: true
        }
        this.blankCall = {
            callID: 0,
            name: '',
            callTypeID: 0,
            script: '',
            active: true
        }
        this.blankInvitation = {
            invitationID: 0,
            name: '',
            invitationTypeID: 0,
            date: '',
            description: '',
            attachments: [],
            active: true
        }
        this.blankType = {
            typeID: 0,
            section: '',
            type: ''
        }
        this.blankComponent = {
            componentID: 0,
            campaignID: 0,
            category: '',
            categoryItemID: 0,
            notes: '',
            duration: 0,
            reminder: 0,
            snooze: 0,
            flowConditionKey: '',
            flowConditionValue: '',
            toID: 0,
            isActivity: false,
            isDelay: false,
            isFlow: false,
            isSkip: false,
            order: 0,
            auth0: '',
            active: true,
            systemDemographics: []
        }
        // this.blankMarketingCampaign = {
        //     id: 0,
        //     secID: '',
        //     category: '',
        //     itemID: 0,
        //     primaryBusinessName: ''
        // }
        this.state = {
            marketingCampaigns: [],
            newMarketingCampaign: JSON.parse(JSON.stringify(this.blankMarketingCampaign)),
            editMarketingCampaign: JSON.parse(JSON.stringify(this.blankMarketingCampaign)),
            marketingActivities: [],
            emails: [],
            newEmail: JSON.parse(JSON.stringify(this.blankEmail)),
            editEmail: JSON.parse(JSON.stringify(this.blankEmail)),
            calls: [],
            newCall: JSON.parse(JSON.stringify(this.blankCall)),
            editCall: JSON.parse(JSON.stringify(this.blankCall)),
            invitations: [],
            newInvitation: JSON.parse(JSON.stringify(this.blankInvitation)),
            editInvitation: JSON.parse(JSON.stringify(this.blankInvitation)),
            types: [],
            newType: { ...this.blankType },
            editType: { ...this.blankType },
            editComponent: { ...this.blankComponent },
            files: [],
            isConfiguringMarketingCampaign: false,
            unsavedChanges: false,
            users: [],
            workflowTypes: []
        };
    }

    componentDidMount() {
        this.getMarketingCampaigns();
        this.getMarketingEmails();
        this.getMarketingCalls();
        this.getMarketingInvitations();
        this.getMarketingTypes();
        this.getNotesCategories();
        this.getUsers();
        this.getWorkflowTypes();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getUsers = () => {
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    getWorkflowTypes = () => {
        fetch('/api/workflows/types/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    workflowTypes: results.data
                });
            });
    }

    getNotesCategories() {
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                const systemDemographics = results.data.filter(item => item.type === 'System Demographics');
                this.setState({
                    systemDemographics: systemDemographics.length > 0 && systemDemographics[0].children != null ? systemDemographics[0].children : []
                });
            });
        return;
    }

    getMarketingCampaigns = (cb) => {
        fetch('/api/marketing2Campaigns/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    marketingCampaigns: results.data,
                }, () => {
                    if (cb != null) cb();
                });
            });
    }

    getMarketingEmails = () => {
        fetch('/api/marketing2Emails/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    emails: results.data,
                });
            });
    }

    getMarketingCalls = () => {
        fetch('/api/marketing2Calls/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    calls: results.data,
                });
            });
    }

    getMarketingInvitations = () => {
        fetch('/api/marketing2Invitations/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    invitations: results.data,
                });
            });
    }

    getMarketingTypes = () => {
        fetch('/api/marketing2Types/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    types: results.data,
                });
            });
    }

    onToggleConfigureMarketingCampaign = (campaignID, isConfiguring) => {
        console.log('Marketing2Container.js/onToggleConfigureMarketingCampaign (campaignID, isConfiguring)', campaignID, isConfiguring)
        this.setState({
            isConfiguringMarketingCampaign: (isConfiguring == null) ? !this.state.isConfiguringMarketingCampaign : isConfiguring
        }, () => {
            if (campaignID != null) {
                fetch('/api/marketing2Campaigns/' + campaignID, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    }
                })
                    .then(results => results.json())
                    .then(results => {
                        const campaign = results.data;
                        // console.log('camp',campaign)
                        this.setState({
                            editMarketingCampaign: {
                                campaignID: campaign.campaignID,
                                name: campaign.name,
                                description: campaign.description,
                                type: campaign.type,
                                startDate: campaign.startDate,
                                endDate: campaign.endDate,
                                components: campaign.components != null ? campaign.components : [],
                                companies: campaign.companies,
                                auth0: campaign.auth0,
                                active: campaign.active,
                                order: campaign.order
                            }
                        });
                    });
            }
        })
    }

    onToggleDuplicateMarketingCampaign = (campaignID) => {
        console.log('Marketing2Container.js/onToggleDuplicateMarketingCampaign (campaignID)', campaignID)
        if (campaignID != null) {
            fetch('/api/marketing2Campaigns/duplicate/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                },
                body: JSON.stringify({
                    campaignID: campaignID
                })
            })
                .then(results => results.json())
                .then(results => {
                    this.handleCancelMarketingCampaign();
                    this.getMarketingCampaigns();
                });
        }
    }

    onEditMarketingCampaign = (campaignID) => {
        const campaign = [...this.state.marketingCampaigns].filter(item => item.campaignID === campaignID)[0];
        this.setState({
            editMarketingCampaign: {
                campaignID: campaignID,
                name: campaign.name,
                description: campaign.description,
                type: campaign.type,
                startDate: campaign.startDate,
                endDate: campaign.endDate,
                components: campaign.components != null ? campaign.components : [],
                companies: campaign.companies,
                auth0: campaign.auth0,
                active: campaign.active
            }
        })
    }

    onEditEmail = (emailID) => {
        const email = [...this.state.emails].filter(item => item.ID === emailID)[0];
        this.setState({
            editEmail: {
                emailID: emailID,
                name: email.Name,
                emailTypeID: email.EmailTypeID,
                subject: email.Subject,
                text: email.Text,
                active: email.Active,
                attachments: email.Attachments != null ? JSON.parse(email.Attachments) : []
            }
        })
    }

    onEditCall = (callID) => {
        const call = [...this.state.calls].filter(item => item.ID === callID)[0];
        this.setState({
            editCall: {
                callID: callID,
                name: call.Name,
                callTypeID: call.CallTypeID,
                script: call.Script,
                active: call.Active
            }
        })
    }

    onEditInvitation = (invitationID) => {
        const invitation = [...this.state.invitations].filter(item => item.ID === invitationID)[0];
        this.setState({
            editInvitation: {
                invitationID: invitationID,
                name: invitation.Name,
                invitationTypeID: invitation.InvitationTypeID,
                date: invitation.Date,
                description: invitation.Description,
                attachments: invitation.Attachments != null ? JSON.parse(invitation.Attachments) : [],
                active: invitation.Active
            }
        })
    }

    onEditType = (typeID) => {
        const type = [...this.state.types].filter(item => item.TypeID === typeID)[0];
        this.setState({
            editType: {
                typeID: typeID,
                section: type.Section,
                type: type.Type,
            }
        })
    }

    onEditComponent = (componentID, isSubCampaign) => {
        if (this.state.editComponent.componentID === componentID || isSubCampaign) return;
        const component = { ...this.state.editMarketingCampaign }.components.filter(item => item.componentID === componentID)[0];
        // console.log(component, componentID, isSubCampaign)
        this.setState({
            editComponent: {
                componentID: componentID,
                active: component.active,
                auth0: component.auth0,
                campaign: component.campaign,
                category: component.category,
                categoryItemID: component.categoryItemID,
                duration: component.duration,
                durationType: 1440,
                flowConditionKey: component.flowConditionKey,
                flowConditionValue: component.flowConditionValue,
                toID: component.toID,
                isActivity: component.isActivity,
                isDelay: component.isDelay,
                isFlow: component.isFlow,
                isSkip: component.isSkip,
                notes: component.notes,
                order: component.order,
                reminder: component.reminder,
                snooze: component.snooze,
                timestamp: component.timestamp
            }
        })
    }

    onCancelEditComponent = () => {
        this.setState({
            editComponent: {
                ...this.blankComponent,
                componentID: 0
            },
            unsavedChanges: false
        })
    }

    handleAddComponent = (e, type, order) => {
        fetch('/api/marketing2Components/', {
            method: 'POST',
            body: JSON.stringify({
                campaignID: this.state.editMarketingCampaign.campaignID,
                category: null,
                categoryItemID: null,
                notes: null,
                duration: null,
                reminder: null,
                snooze: null,
                flowConditionKey: null,
                flowConditionValue: null,
                toID: null,
                isActivity: type === 'isActivity',
                isDelay: type === 'isDelay',
                isFlow: type === 'isFlow',
                isSkip: type === 'isSkip',
                order: order,
                auth0: this.props.user,
                active: true
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editComponent: { ...this.blankComponent, componentID: results.componentID, order: order },
                        unsavedChanges: false
                    }, () => {
                        this.getMarketingCampaigns();
                        this.onToggleConfigureMarketingCampaign(this.state.editMarketingCampaign.campaignID, true);
                    });
                }
            });
    }

    handleSaveComponent = (e, type, order) => {
        fetch('/api/marketing2Components/' + this.state.editComponent.componentID, {
            method: 'PUT',
            body: JSON.stringify({
                campaignID: this.state.editMarketingCampaign.campaignID,
                category: this.state.editComponent.category,
                categoryItemID: this.state.editComponent.categoryItemID,
                notes: this.state.editComponent.notes,
                duration: this.state.editComponent.duration,
                reminder: this.state.editComponent.reminder,
                snooze: this.state.editComponent.snooze,
                flowConditionKey: this.state.editComponent.flowConditionKey,
                flowConditionValue: this.state.editComponent.flowConditionValue,
                toID: this.state.editComponent.toID,
                isActivity: type === 'isActivity',
                isDelay: type === 'isDelay',
                isFlow: type === 'isFlow',
                isSkip: type === 'isSkip',
                order: order,
                auth0: this.state.editComponent.auth0,
                active: this.state.editComponent.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editComponent: { ...this.blankComponent, componentID: 0 },
                        unsavedChanges: false
                    }, () => {
                        this.getMarketingCampaigns();
                        this.onToggleConfigureMarketingCampaign(this.state.editMarketingCampaign.campaignID, true);
                    });
                }
            });
    }

    handleDeleteComponent = () => {
        fetch('/api/marketing2Components/' + this.state.editComponent.componentID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editComponent: { ...this.blankComponent },
                        unsavedChanges: false
                    }, () => {
                        this.getMarketingCampaigns();
                        this.onToggleConfigureMarketingCampaign(this.state.editMarketingCampaign.campaignID, true);
                    });
                }
            });
    }

    onChangeMarketingCampaign = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisMarketingCampaign = (type === 'edit') ? prevState.editMarketingCampaign : prevState.newMarketingCampaign;
            switch (e.target.name) {
                case "active":
                    thisMarketingCampaign[e.target.name] = !thisMarketingCampaign[e.target.name];
                    break;
                default:
                    thisMarketingCampaign[e.target.name] = e.target.value;
            }
            return (type === 'edit') ?
                {
                    editMarketingCampaign: thisMarketingCampaign,
                    unsavedChanges: true
                }
                : {
                    newMarketingCampaign: thisMarketingCampaign,
                    unsavedChanges: true
                };
        });
    }

    onChangeEmail = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisEmail = (type === 'edit') ? prevState.editEmail : prevState.newEmail;
            switch (e.target.name) {
                case "attachment":
                    if (e.target.value !== 0) {
                        const attachmentIndex = parseInt(e.target.id.split('_')[1]);
                        if (attachmentIndex === -1) {
                            thisEmail.attachments.push({ FileID: e.target.value });
                        } else {
                            thisEmail.attachments[attachmentIndex] = { FileID: e.target.value };
                        }
                    }
                    break;
                default:
                    thisEmail[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editEmail: thisEmail,
                    unsavedChanges: true
                }
                : {
                    newEmail: thisEmail,
                    unsavedChanges: true
                };
        });
    }

    onChangeCall = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisCall = (type === 'edit') ? prevState.editCall : prevState.newCall;
            switch (e.target.name) {
                default:
                    thisCall[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editCall: thisCall,
                    unsavedChanges: true
                }
                : {
                    newCall: thisCall,
                    unsavedChanges: true
                };
        });
    }

    onChangeInvitation = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisInvitation = (type === 'edit') ? prevState.editInvitation : prevState.newInvitation;
            switch (e.target.name) {
                case "attachment":
                    if (e.target.value !== 0) {
                        const attachmentIndex = parseInt(e.target.id.split('_')[1]);
                        if (attachmentIndex === -1) {
                            thisInvitation.attachments.push({ FileID: e.target.value });
                        } else {
                            thisInvitation.attachments[attachmentIndex] = { FileID: e.target.value };
                        }
                    }
                    break;
                default:
                    thisInvitation[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editInvitation: thisInvitation,
                    unsavedChanges: true
                } : {
                    newInvitation: thisInvitation,
                    unsavedChanges: true
                };
        });
    }

    onChangeType = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisType = (type === 'edit') ? prevState.editType : prevState.newType;
            switch (e.target.name) {
                default:
                    thisType[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editType: thisType,
                    unsavedChanges: true
                } : {
                    newType: thisType,
                    unsavedChanges: true
                };
        });
    }

    onChangeComponent = (e, cb) => {
        if (e.persist != null) e.persist();
        this.setState((prevState) => {
            let thisComponent = prevState.editComponent;
            switch (e.target.type) {
                case "checkbox":
                    thisComponent[e.target.name] = !thisComponent[e.target.name];
                    break;
                case "number":
                    thisComponent[e.target.name] = parseFloat(e.target.value);
                    break;
                default:
                    thisComponent[e.target.name] = e.target.value;
            }
            return {
                editComponent: thisComponent,
                unsavedChanges: true
            };
        }, () => {
            if (cb != null) cb();
        });
    }

    handleCancelMarketingCampaign = () => {
        this.setState({
            editMarketingCampaign: { ...this.blankMarketingCampaign },
            unsavedChanges: false
        })
    }

    handleCancelEmail = () => {
        this.setState({
            editEmail: { ...this.blankEmail },
            unsavedChanges: false
        })
    }

    handleCancelCall = () => {
        this.setState({
            editCall: { ...this.blankCall },
            unsavedChanges: false
        })
    }

    handleCancelInvitation = () => {
        this.setState({
            editInvitation: { ...this.blankInvitation },
            unsavedChanges: false
        })
    }

    handleCancelType = () => {
        this.setState({
            editType: { ...this.blankType },
            unsavedChanges: false
        })
    }

    handleEditMarketingCampaign = () => {
        fetch('/api/marketing2Campaigns/' + this.state.editMarketingCampaign.campaignID, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editMarketingCampaign.name,
                description: this.state.editMarketingCampaign.description,
                type: this.state.editMarketingCampaign.type,
                startDate: this.state.editMarketingCampaign.startDate,
                endDate: this.state.editMarketingCampaign.endDate,
                components: this.state.editMarketingCampaign.components,
                auth0: this.props.user,
                active: this.state.editMarketingCampaign.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editMarketingCampaign: this.blankMarketingCampaign,
                        unsavedChanges: false
                    }, this.getMarketingCampaigns);
                }
            });
    }

    handleEditEmail = () => {
        fetch('/api/marketing2Emails/' + this.state.editEmail.emailID, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editEmail.name,
                emailTypeID: this.state.editEmail.emailTypeID,
                subject: this.state.editEmail.subject,
                text: this.state.editEmail.text,
                attachments: this.state.editEmail.attachments.map(attachment => attachment.FileID),
                active: this.state.editEmail.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editEmail: this.blankEmail,
                        unsavedChanges: false
                    }, () => this.getMarketingEmails());
                }
            });
    }

    handleEditCall = () => {
        fetch('/api/marketing2Calls/' + this.state.editCall.callID, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editCall.name,
                callTypeID: this.state.editCall.callTypeID,
                script: this.state.editCall.script,
                active: this.state.editCall.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editCall: this.blankCall,
                        unsavedChanges: false
                    }, () => this.getMarketingCalls());
                }
            });
    }

    handleEditInvitation = () => {
        fetch('/api/marketing2Invitations/' + this.state.editInvitation.invitationID, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editInvitation.name,
                invitationTypeID: this.state.editInvitation.invitationTypeID,
                date: this.state.editInvitation.date,
                description: this.state.editInvitation.description,
                attachments: this.state.editInvitation.attachments.map(attachment => attachment.FileID),
                active: this.state.editInvitation.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editInvitation: this.blankInvitation,
                        unsavedChanges: false
                    }, () => this.getMarketingInvitations());
                }
            });
    }

    handleEditType = () => {
        fetch('/api/marketing2Types/' + this.state.editType.typeID, {
            method: 'PUT',
            body: JSON.stringify({
                section: this.state.editType.section,
                type: this.state.editType.type,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editType: this.blankType,
                        unsavedChanges: false
                    }, () => this.getMarketingTypes());
                }
            });
    }

    onDeleteMarketingCampaign = (campaignID) => {
        fetch('/api/marketing2Campaigns/' + campaignID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ unsavedChanges: false });
                    this.getMarketingCampaigns();
                }
            });
    }

    onDeleteEmail = (emailID) => {
        fetch('/api/marketing2Emails/' + emailID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ unsavedChanges: false });
                    this.getMarketingEmails();
                }
            });
    }

    onDeleteCall = (callID) => {
        fetch('/api/marketing2Calls/' + callID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ unsavedChanges: false });
                    this.getMarketingCalls();
                }
            });
    }

    onDeleteInvitation = (invitationID) => {
        fetch('/api/marketing2Invitations/' + invitationID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ unsavedChanges: false });
                    this.getMarketingInvitations();
                }
            });
    }

    onDeleteType = (typeID) => {
        fetch('/api/marketing2Types/' + typeID, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ unsavedChanges: false });
                    this.getMarketingTypes();
                }
            });
    }

    handleAddMarketingCampaign = (e) => {
        fetch('/api/marketing2Campaigns/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newMarketingCampaign.name,
                description: this.state.newMarketingCampaign.description,
                type: this.state.newMarketingCampaign.type,
                startDate: this.state.newMarketingCampaign.startDate,
                endDate: this.state.newMarketingCampaign.endDate,
                auth0: this.props.user,
                active: this.state.newMarketingCampaign.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newMarketingCampaign: { ...this.blankMarketingCampaign },
                        unsavedChanges: false
                    }, this.getMarketingCampaigns);
                }
            });
    }

    handleAddEmail = (e) => {
        fetch('/api/marketing2Emails/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newEmail.name,
                emailTypeID: this.state.newEmail.emailTypeID,
                subject: this.state.newEmail.subject,
                text: this.state.newEmail.text,
                attachments: this.state.newEmail.attachments.map(attachment => attachment.FileID),
                active: this.state.newEmail.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newEmail: { ...this.blankEmail },
                        unsavedChanges: false
                    }, () => this.getMarketingEmails());
                }
            });
    }

    handleAddCall = (e) => {
        fetch('/api/marketing2Calls/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newCall.name,
                callTypeID: this.state.newCall.callTypeID,
                script: this.state.newCall.script,
                active: this.state.newCall.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newCall: this.blankCall,
                        unsavedChanges: false
                    }, () => this.getMarketingCalls());
                }
            });
    }

    handleAddInvitation = (e) => {
        fetch('/api/marketing2Invitations/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newInvitation.name,
                invitationTypeID: this.state.newInvitation.invitationTypeID,
                date: this.state.newInvitation.date,
                description: this.state.newInvitation.description,
                attachments: this.state.newInvitation.attachments.map(attachment => attachment.FileID),
                active: this.state.newInvitation.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newInvitation: this.blankInvitation,
                        unsavedChanges: false
                    }, () => this.getMarketingInvitations());
                }
            });
    }

    handleAddType = (e) => {
        fetch('/api/marketing2Types/', {
            method: 'POST',
            body: JSON.stringify({
                section: this.state.newType.section,
                type: this.state.newType.type,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newType: this.blankType,
                        unsavedChanges: false
                    }, () => this.getMarketingTypes());
                }
            });
    }

    handleRemoveEmailAttachment = (index, type) => {
        this.setState((prevState) => {
            let thisEmail = (type === 'edit') ? prevState.editEmail : prevState.newEmail;
            thisEmail.attachments.splice(index, 1)
            return (type === 'edit') ? { editEmail: thisEmail } : { newEmail: thisEmail };
        });
    }

    handleRemoveInvitationAttachment = (index, type) => {
        this.setState((prevState) => {
            let thisInvitation = (type === 'edit') ? prevState.editInvitation : prevState.newInvitation;
            thisInvitation.attachments.splice(index, 1)
            return (type === 'edit') ? { editInvitation: thisInvitation } : { newInvitation: thisInvitation };
        });
    }

    updateFiles = (fileArr) => {
        this.setState({
            files: fileArr
        })
    }

    reorder = (data = [...this.state.editMarketingCampaign.components]) => {
        let components = [];
        let counter = 0;
        data = data.map((component) => {
            let newOrder = null;
            if (components.findIndex(item => item.componentID === component.componentID) === -1) {
                components.push({ ComponentID: component.componentID })
                newOrder = ((counter + 1) * 10);
                counter++;
            }
            return { ...component, order: newOrder }
        })
        // console.log(data)
        this.setState((prevState) => {
            let obj = { ...prevState };
            obj.editMarketingCampaign.components = data;
            return obj;
        }, () => {
            fetch('/api/marketing2Components/reorder', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                },
                body: JSON.stringify(
                    { orders: data.map(item => { return { id: item.componentID, order: item.order } }) }
                )
            })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })

        });
    }

    render() {
        return (
            <>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                {!this.state.isConfiguringMarketingCampaign &&
                    <>
                        <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <h1>Workflows</h1>
                                </Col>
                            </Row>
                        </PermissionWrapper>
                        <CollapseCard title="Workflows" open={true}>
                            <Marketing2Campaigns
                                clientToken={this.props.clientToken}
                                user={this.props.user}
                                workflowTypes={this.state.workflowTypes}
                                marketingActivities={this.state.marketingActivities}
                                marketingCampaigns={this.state.marketingCampaigns}
                                newMarketingCampaign={this.state.newMarketingCampaign}
                                editMarketingCampaign={this.state.editMarketingCampaign}
                                onToggleConfigureMarketingCampaign={this.onToggleConfigureMarketingCampaign}
                                onToggleDuplicateMarketingCampaign={this.onToggleDuplicateMarketingCampaign}
                                onChange={this.onChangeMarketingCampaign}
                                onEdit={this.onEditMarketingCampaign}
                                onDelete={this.onDeleteMarketingCampaign}
                                handleAdd={this.handleAddMarketingCampaign}
                                handleEdit={this.handleEditMarketingCampaign}
                                handleCancel={this.handleCancelMarketingCampaign}
                            />
                        </CollapseCard>
                        <CollapseCard title="Workflow Activities" open={true}>
                            {/* <CollapseCard title="Unassigned Activities" open={false}>
                        <Marketing2Activities
                            clientToken={this.props.clientToken}
                            marketingActivities={this.state.marketingActivities.filter(activity => activity.Campaign == null)}
                            marketingCampaigns={this.state.marketingCampaigns}
                            onChange={this.onChangeMarketingCampaign}
                        />
                    </CollapseCard> */}
                            <CollapseCard title="Email Templates" open={false}>
                                <Marketing2Emails
                                    clientToken={this.props.clientToken}
                                    types={[...this.state.types.filter(type => type.Section === 'Email')]}
                                    emails={this.state.emails}
                                    newEmail={this.state.newEmail}
                                    editEmail={this.state.editEmail}
                                    files={this.state.files}
                                    onChange={this.onChangeEmail}
                                    onEdit={this.onEditEmail}
                                    onDelete={this.onDeleteEmail}
                                    handleAdd={this.handleAddEmail}
                                    handleEdit={this.handleEditEmail}
                                    handleCancel={this.handleCancelEmail}
                                    handleRemoveAttachment={this.handleRemoveEmailAttachment}
                                />
                            </CollapseCard>
                            <CollapseCard title="Call Templates" open={false}>
                                <Marketing2Calls
                                    clientToken={this.props.clientToken}
                                    types={[...this.state.types.filter(type => type.Section === 'Call')]}
                                    calls={this.state.calls}
                                    newCall={this.state.newCall}
                                    editCall={this.state.editCall}
                                    onChange={this.onChangeCall}
                                    onEdit={this.onEditCall}
                                    onDelete={this.onDeleteCall}
                                    handleAdd={this.handleAddCall}
                                    handleEdit={this.handleEditCall}
                                    handleCancel={this.handleCancelCall}
                                />
                            </CollapseCard>
                            <CollapseCard title="Invitation Templates" open={false}>
                                <Marketing2Invitations
                                    clientToken={this.props.clientToken}
                                    types={[...this.state.types.filter(type => type.Section === 'Invitation')]}
                                    invitations={this.state.invitations}
                                    newInvitation={this.state.newInvitation}
                                    editInvitation={this.state.editInvitation}
                                    files={this.state.files}
                                    onChange={this.onChangeInvitation}
                                    onEdit={this.onEditInvitation}
                                    onDelete={this.onDeleteInvitation}
                                    handleAdd={this.handleAddInvitation}
                                    handleEdit={this.handleEditInvitation}
                                    handleCancel={this.handleCancelInvitation}
                                    handleRemoveAttachment={this.handleRemoveInvitationAttachment}
                                />
                            </CollapseCard>
                        </CollapseCard>
                        <CollapseCard title="Workflow Files" open={false}>
                            <Files
                                user={this.props.user}
                                refreshUser={this.props.refreshUser}
                                callback={this.updateFiles}
                                clientToken={this.props.clientToken}
                            />
                        </CollapseCard>
                        {/* <CollapseCard title="Campaign Components Management" open={false}>
                </CollapseCard> */}
                        <CollapseCard title="Workflow Task Management" open={false}>
                            <Marketing2Types
                                clientToken={this.props.clientToken}
                                types={this.state.types}
                                newType={this.state.newType}
                                editType={this.state.editType}
                                onChange={this.onChangeType}
                                onEdit={this.onEditType}
                                onDelete={this.onDeleteType}
                                handleAdd={this.handleAddType}
                                handleEdit={this.handleEditType}
                                handleCancel={this.handleCancelType}
                            />
                        </CollapseCard>
                    </>
                }
                {this.state.isConfiguringMarketingCampaign && this.state.editMarketingCampaign.campaignID !== 0 &&
                    <Marketing2ConfigureCampaign
                        clientToken={this.props.clientToken}
                        users={this.state.users}
                        user={this.props.user}
                        calls={this.state.calls}
                        emails={this.state.emails}
                        invitations={this.state.invitations}
                        campaign={this.state.editMarketingCampaign}
                        editComponent={this.state.editComponent}
                        systemDemographics={this.state.systemDemographics}
                        marketingCampaigns={this.state.marketingCampaigns}
                        onToggleConfigureMarketingCampaign={this.onToggleConfigureMarketingCampaign}
                        reorder={this.reorder}
                        onChange={this.onChangeComponent}
                        onEditComponent={this.onEditComponent}
                        onCancelEditComponent={this.onCancelEditComponent}
                        handleAddComponent={this.handleAddComponent}
                        handleSaveComponent={this.handleSaveComponent}
                        handleDeleteComponent={this.handleDeleteComponent}
                        checkPermission={this.props.checkPermission} 
                    // onChange={this.onChangeMarketingCampaign}
                    // onEdit={this.onEditMarketingCampaign}
                    // onDelete={this.onDeleteMarketingCampaign}
                    // handleAdd={this.handleAddMarketingCampaign}
                    // handleEdit={this.handleEditMarketingCampaign}
                    // handleCancel={this.handleCancelMarketingCampaign}
                    />
                }
            </>
        );

    }
}

export default Marketing2Container;
